export const SendCommandName = 'SendCommandComponent';
